// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"105":"5dc76abf","239":"95b0626d","732":"19e4b753","977":"c6dda33f"}[chunkId] + ".chunk.js";
};